import React from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { Button,} from "@aidkitorg/component-library";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { createStagedComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { usePieChartFormState } from "../hooks/usePieChartFormState";
import { PieChartFormFields } from "./PieChartFormFields";
import { useLocalizedStrings } from "../../../Localization";

export const PieChartComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode }) => {
  const L = useLocalizedStrings()
  const {
    title, setTitle,
    description, setDescription,
    groupDataField, setGroupDataField,
    aggregation, setAggregation,
    dataField, setDataField,
    buildPieChartObject,
    isFormStateValid
  } = usePieChartFormState()

  const {
    setStagedComponents,
    getDashboardComponentTranslation
  } = useDashboards()

  const savePieChartComponent = async () => {
    const newPieChart = buildPieChartObject()

    const translations = await getDashboardComponentTranslation(newPieChart)

    if (translations && translations.success) {
      const stagedComponent = createStagedComponent(newPieChart, translations.data)
      setStagedComponents((prev) => ([...prev, stagedComponent]))
      setDisplayMode('create')
    } else {
      console.error('Failed to translate pie chart component:', newPieChart)
      // TODO: Show user-friendly error message
    }
  }

  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-xl font-bold text-gray-900">
        {L.admin_panel.dashboards.add_pie_chart}
      </div>

      <PieChartFormFields 
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        groupDataField={groupDataField}
        setGroupDataField={setGroupDataField}
        aggregation={aggregation}
        setAggregation={setAggregation}
        dataField={dataField}
        setDataField={setDataField}
      />

      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">{L.admin_panel.dashboards.cancel}</Button>
        <Button isDisabled={!isFormStateValid} onClick={savePieChartComponent} className="!w-1/2">{L.admin_panel.dashboards.save}</Button>
      </div>
    </div>
  )
}